<template>
  <div :style="multiple ? 'width: 250px' : 'width: 110px'">
    <item-select v-model="dd"
                 :disabled="disabled"
                 :options="options"
                 :allow-create="true"
                 :multiple="multiple" />
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeLargeAmount",
  mixins: [LibProductItem],
  props: {
    value: [Number, Array]
  },
  computed: {
    options() {
      return this.list || this.largeAmountOptions()
    },
    dd: {
      get: function () {
        let r = this.value
        if (r !== null && r !== undefined) {
          let new_r = []
          if (this.multiple) {
            for (let i of r) {
              new_r.push(Math.round(i) / 10000)
            }
            r = new_r
          } else {
            r = Math.round(r) / 10000
          }
        }

        return r
      },
      set: function (n) {
        if (this.multiple) {
          let new_n = []
          for (let i of n) {
            new_n.push(parseInt((i || 0) * 10000))
          }
          n = new_n
        } else {
          n = parseInt((n || 0) * 10000)
        }

        this.$emit('input', n)
      }
    }
  }
}
</script>
